import React, { FC } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { AutocompleteItem } from '../AutocompleteItem';
import { RenderHighlightedParts } from '../../../../../components/highlight/RenderHighlightedParts';
import { ReactComponent as Enter } from '../../../../../../../public/img/icons/subdirectory_arrow_left.svg';
import { autocompleteDelimiters } from '../autocompleteConstants';

type Props = {
  label: string;
  selected: boolean;
  item: string;
  onClick: (event: React.MouseEvent<HTMLSpanElement>) => void;
};

export const AutocompleteQueryItem: FC<Props> = ({
  selected,
  label,
  onClick,
  item,
}) => (
  <AutocompleteItem isSelected={selected} onClick={onClick}>
    <span className="search-bar-dropdown__cell" title={label}>
      <span className="autocomplete-query-item">
        <RenderHighlightedParts
          renderHighlightedParts={renderHighlightedParts}
          config={autocompleteDelimiters}
        >
          {item}
        </RenderHighlightedParts>
      </span>
      <span
        className={classNames('autocomplete-query-item__enter', {
          'autocomplete-query-item__enter--selected': selected,
        })}
      >
        <FormattedMessage id="search/components/search-bar/dropdown/query/AutocompleteQueryItem.tsx/1" />
        <Enter className="autocomplete-query-item__icon" />
      </span>
    </span>
  </AutocompleteItem>
);

function renderHighlightedParts(
  item: { highlighted: boolean; value: string },
  index: number,
) {
  if (item.highlighted) {
    return (
      <b className="autocomplete-highlight" key={index}>
        {item.value}
      </b>
    );
  }
  return item.value;
}
